<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text">
          {{ $t("crud.notF") }}
        </v-card-title>
        <v-card-text>
          {{ $t("crud.notFa") }}<br /><br />
          {{ $t("crud.notFb") }}
          <v-spacer></v-spacer>
          <v-btn large color="accent" @click="backHome" class="mt-15">{{
            $t("crud.close")
          }}</v-btn>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";

export default {
  name: "NotFound",
  components: { ToolbarAuth, Navigation },
  data() {
    return {};
  },
  methods: {
    backHome() {
      this.$router.push({ name: "dashboard" });
    },
  },
  computed: {},
  created() {},
};
</script>

<style scoped></style>
